import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Mountain, Flame, Feather, MapPin, Sun } from 'lucide-react';
const groups = [{
  name: 'Wanderkin Collective',
  description: 'For families and gentle strollers who believe magic hides in the moss.',
  difficulty: 'Easy',
  icon: <Feather className="w-6 h-6" data-id="element-88" />,
  color: 'bg-emerald-100 text-emerald-800'
}, {
  name: 'Ridgeline Rovers',
  description: 'High-altitude seekers chasing horizons and conquering peaks.',
  difficulty: 'Challenging',
  icon: <Mountain className="w-6 h-6" data-id="element-89" />,
  color: 'bg-stone-200 text-stone-800'
}, {
  name: 'Cairn Seekers',
  description: 'Navigators of the unknown, focusing on orienteering and off-trail skills.',
  difficulty: 'Moderate',
  icon: <MapPin className="w-6 h-6" data-id="element-90" />,
  color: 'bg-amber-100 text-amber-800'
}, {
  name: 'Trailmark Fellowship',
  description: 'Long-distance endurance walkers covering vast terrains together.',
  difficulty: 'Hard',
  icon: <Sun className="w-6 h-6" data-id="element-91" />,
  color: 'bg-orange-100 text-orange-800'
}, {
  name: 'Hearthstone Trekkers',
  description: 'Social hikers who prioritize the journey and the post-hike meal.',
  difficulty: 'Moderate',
  icon: <Flame className="w-6 h-6" data-id="element-92" />,
  color: 'bg-rose-100 text-rose-800'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TrailGroups() {
  return <section className="py-24 bg-white" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-95">
          <h2 className="text-4xl md:text-5xl font-serif text-forest-900 mb-4" data-id="element-96">
            Find Your Tribe
          </h2>
          <p className="text-lg text-stone-600" data-id="element-97">
            Every path has a different rhythm. Choose the group that matches
            your pace and spirit.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-98">
          {groups.map((group, idx) => <motion.div key={idx} variants={item} className="group relative bg-earth-50 rounded-2xl p-8 border border-earth-100 hover:border-earth-300 transition-colors duration-300" data-id="element-99">
              <div className={`inline-flex items-center justify-center p-3 rounded-xl ${group.color} mb-6`} data-id="element-100">
                {group.icon}
              </div>

              <h3 className="text-2xl font-serif font-bold text-forest-900 mb-3 group-hover:text-sunset-600 transition-colors duration-300" data-id="element-101">
                {group.name}
              </h3>

              <p className="text-stone-600 mb-6 leading-relaxed" data-id="element-102">
                {group.description}
              </p>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-earth-200" data-id="element-103">
                <span className="text-sm font-medium text-stone-500 uppercase tracking-wider" data-id="element-104">
                  Difficulty
                </span>
                <span className="px-3 py-1 bg-white rounded-full text-sm font-semibold text-forest-800 border border-earth-200" data-id="element-105">
                  {group.difficulty}
                </span>
              </div>
            </motion.div>)}

          {/* Call to action card */}
          <motion.div variants={item} className="flex flex-col items-center justify-center bg-forest-900 rounded-2xl p-8 text-center text-white" data-id="element-106">
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-107">
              Not sure where to start?
            </h3>
            <p className="text-forest-100 mb-8" data-id="element-108">
              Join our monthly "Open Trail" day where all groups converge for a
              grand picnic.
            </p>
            <button className="bg-white text-forest-900 px-6 py-3 rounded-full font-medium hover:bg-earth-100 transition-colors duration-300 w-full" data-id="element-109">
              Contact Us
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}